<template>
  <b-modal
    id="modal-field"
    :title="editMode == true ? $t('general.edit') : $t('general.add_application')"
    :ok-title="editMode == true ? $t('general.edit') : $t('general.save')"
    cancel-variant="outline-secondary"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @show="showModal"
    @ok="onSubmit"
  >
    <validation-observer ref="worksAddModal">
      <b-row class="material">



         <b-col md="12">
          <b-form-group :label="$t('reference.categoriya')">
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('reference.categoriya')"
              rules="required"
            > -->
              <v-select
                v-model="works.category"
                :get-option-label="(el) => { return el.title[$i18n.locale] }"
                :options="GET_ALL_BRIGADE_WORK_CATEGORIES.results"
                @input="onWorkCategorySelected"
              >
                <li slot="list-footer" class="pagination">
                  <button :disabled="!GET_ALL_BRIGADE_WORK_CATEGORIES.previous" @click="previousCategories()">
                    {{ $t("prev") }}
                  </button>
                  <button :disabled="!GET_ALL_BRIGADE_WORK_CATEGORIES.next" @click="nextCategories()">
                    {{ $t("next") }}
                  </button>
                </li>
              </v-select>
              <!-- <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider> -->
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group :label="$t('table.product_type')">
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('table.product_type')"
              rules="required"
            > -->
              <v-select
                v-model="works.work_type"
                :get-option-label="(el) => { return el.title[$i18n.locale] }"
                :options="GET_ALL_BRIGADE_WORKS.results"
                :filterable="false"
              >
                <!-- @search="onSearch1" -->
                <li slot="list-footer" class="pagination">
                  <button :disabled="!GET_ALL_BRIGADE_WORKS.previous" @click="previousWorkType()">
                    {{ $t("prev") }}
                  </button>
                  <button :disabled="!GET_ALL_BRIGADE_WORKS.next" @click="nextWorkType()">
                    {{ $t("next") }}
                  </button>
                </li>
              </v-select>

              <!-- <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider> -->
          </b-form-group>
        </b-col>








        <b-col md="12">
          <b-form-group :label="$t('price_for_unit_of_measurement')">
            <validation-provider
              #default="{ errors }"
              :name="$t('price_for_unit_of_measurement')"
              rules="required"
            >
              <b-form-input
                v-model="works.price_for_each"
                type="text"
                @input="formatPrice(works.price_for_each, 'price_for_each')"
                onkeypress="return /[0-9,/.]/i.test(event.key)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group :label="$t('workload')">
            <validation-provider
              #default="{ errors }"
              :name="$t('workload')"
              rules="required"
            >
              <b-form-input
                v-model="works.workload"
                type="text"
                @input="formatPrice(works.workload, 'workload')"
                onkeypress="return /[0-9,/.]/i.test(event.key)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      
        <b-col md="12">
          <b-form-group :label="$t('contact.comment')">
            <validation-provider
              #default="{ errors }"
              :name="$t('contact.comment')"
              rules="required"
            >
              <b-form-textarea v-model="works.created_comment" type="text" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>

  </b-modal>
</template>



<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BModal,
BSidebar, BButton, BBadge, VBToggle, BSpinner, } from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@core/utils/validations/validations";
import priceFormatMixin from "@/mixins/priceFormatMixin";
import { getUserData } from '@/auth/utils'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BModal,

    BSidebar, 
    BButton,
    BBadge,
    BSpinner,
  },
  props: {
    works_data: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [priceFormatMixin],
  data() {
    return {
      // ===============  PRIMARY_DATA_SECTION START ===============
      required,

      loading: false,
      works: {
        category: '',

        id: null,
        brigade: null,
        work_type: null,
        work_type_title: '',
        storage: null,

        price_for_each: null,
        workload: null,
        created_comment: null,
        unity: ''
      },
      editMode: false,
      brigadeWorkCategories: 1,
      brigadeWorkTypes: 1,
    };
    // ===============  PRIMARY_DATA_SECTION END ===============
  },
  watch: {
  
  },
  computed: {
    ...mapGetters("materials", [
      "GET_PRODUCT_CATEGORIES",
    ]),
    ...mapGetters('brigadeWorks', ['GET_ALL_BRIGADE_WORKS', 'GET_ALL_BRIGADE_WORK_CATEGORIES']),

    // ...mapGetters('serviceDesk', ['getProduct', 'getProductList']),

   
  },
  async mounted() {




    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_PRODUCT_CATEGORIES({ mini: true });
    this.GET_PRODUCT_CATEGORIES.unshift({
      id: null,
      title: this.$i18n.locale == "ru" ? "Все" : "Barchasi",
    });
    await this.FETCH_BRIGADE();
    await this.FETCH_ALL_BRIGADE_WORK_CATEGORIES();
    // ===============  PRIMARY_REQUESTS_SECTION END ===============



  },
  methods: {
    ...mapActions("materials", [
      "FETCH_PRODUCT_CATEGORIES",
    ]),
    ...mapActions("brigade", [
      "FETCH_BRIGADE",
    ]),
   
 
    ...mapActions('brigadeWorks', ['FETCH_ALL_BRIGADE_WORKS', 'FETCH_ALL_BRIGADE_WORK_CATEGORIES']),








    // ===============  ON_WORK_CATEGORY_SELECTED START ===============
    async onWorkCategorySelected(data) {
      console.log(data)
      if (data.id == 0) {
        await this.FETCH_ALL_BRIGADE_WORKS({ pagination: "number" });
      } else {
        await this.FETCH_ALL_BRIGADE_WORKS({ 
          category: data.id, 
          pagination: "number",
        });
      }
    },
    // ===============  ON_WORK_CATEGORY_SELECTED END ===============


   






    // ===============  FETCH_PREVIOUS_OR_NEXT_PAGE START ===============
    async previousCategories() {
      if (this.GET_ALL_BRIGADE_WORK_CATEGORIES.previous) {
        this.brigadeWorkCategories--;

        await this.FETCH_ALL_BRIGADE_WORK_CATEGORIES({ page: this.brigadeWorkCategories, pagination: "number" });
      }
    },
    async nextCategories() {
      if (this.GET_ALL_BRIGADE_WORK_CATEGORIES.next) {
        this.brigadeWorkCategories++;

        await this.FETCH_ALL_BRIGADE_WORK_CATEGORIES({ page: this.brigadeWorkCategories, pagination: "number" });
      }
    },
    
    
    async previousWorkType() {
      if (this.GET_ALL_BRIGADE_WORKS.previous) {
        this.brigadeWorkTypes--;

        await this.FETCH_ALL_BRIGADE_WORKS({ page: this.brigadeWorkTypes, pagination: "number", category: this.works.category?.id });
      }
    },
    async nextWorkType() {
      if (this.GET_ALL_BRIGADE_WORKS.next) {
        this.brigadeWorkTypes++;

        await this.FETCH_ALL_BRIGADE_WORKS({ page: this.brigadeWorkTypes, pagination: "number", category: this.works.category?.id });
      }
    },
    // ===============  FETCH_PREVIOUS_OR_NEXT_PAGE END ===============









    // ===============  FORMAT_PRICE_SECTION START ===============
    formatPrice(value, type) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);

        if (type == "price_for_each") {
          this.works.price_for_each = currency;
        }else if (type == "workload") {
          this.works.workload = currency;
        }
      }
      return 0;
    },
    // ===============  FORMAT_PRICE_SECTION END ===============









    // ===============  SHOW_MODAL_SECTION START ===============
    showModal() {
      this.editMode = this.$route.params.editMode;
      this.works = {
        id: null,
        brigade: null,
        work_type: null,
        storage: null,

        price_for_each: null,
        workload: null,
        created_comment: null,
      };

      if (!this.works_data) {
        return;
      }

      if (typeof this.works_data === "object" && this.works_data !== null) {
        if (!this.works_data) {
          return;
        }
        this.works.id = this.works_data.id;
        this.works.brigade = this.works_data.brigade;
        this.works.work_type = this.works_data.work_type;
        this.works.price_for_each = this.works_data.price_for_each;
        this.works.workload = this.works_data.workload;
        this.works.created_comment = this.works_data.created_comment;
        this.works.storage = this.works_data.storage;
      }
    },
    // ===============  SHOW_MODAL_SECTION END ===============











    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      await this.$refs.worksAddModal.validate().then(async (success) => {
        if (!success) {
          this.$_errToast({ message: this.$t("all_fields_are_required") });
          return;
        }
        try {
          this.$nextTick(() => {
            this.$route.params.editMode = false;
            this.$emit("onSave", this.works);
            this.$bvModal.hide("modal-field");
          });
          this.$_okToast();
        } catch (err) {
          console.log(err);
          // this.$_errToast('Error')
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============







    
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.material .vs--disabled .vs__dropdown-toggle,
[dir] .vs--disabled .vs__clear,
[dir] .vs--disabled .vs__search,
[dir] .vs--disabled .vs__selected,
[dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: transparent !important;
}


.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}


</style>
